import { JoinUsSection } from "@/components/sections/section-join-us";
import { TeamSection } from "@/components/sections/section-team";

export default function EquipePage() {
  return (
    <div className="min-h-screen bg-n-bg-1">
      <TeamSection />

      <JoinUsSection />
    </div>
  );
}
